<template>
  <div class="carousel-card">
    <a-carousel :autoplay="true"
                arrows
                dotsClass="dotstyle">
      <div slot="prevArrow"
           class="custom-slick-arrow"
           style="left: 10px; z-index: 10">
        <a-icon type="left-circle" />
      </div>
      <div slot="nextArrow"
           class="custom-slick-arrow"
           style="right: 10px">
        <a-icon type="right-circle" />
      </div>
      <div v-for="item in picList"
           :key="item.id"
           @click="handleClick(item)">
        <IconWrap :height="559"
                  :width="243"
                  :url="picHandle(item)"> </IconWrap>
      </div>
    </a-carousel>
  </div>
</template>
<script>
const baseUrl = process.env.VUE_APP_BASE_IMGURL
export default {
  props: {
    picture: Array
  },
  data() {
    return {
      baseUrl,
      picList: []
    }
  },
  watch: {
    picture: {
      handler(val) {
        if (val) {
          this.picList = val.filter((item) => item.systemFile !== null)
        }
      },
      immediate: true,
      deep: true
    }
  },
  mounted() {
    if (this.picture && this.picture.length > 0) {
      this.picList = this.picture.filter((item) => item.systemFile !== null)
    }
  },
  methods: {
    picHandle(item) {
      if (item.systemFile !== null) {
        return baseUrl + item.systemFile.filePath
      }
    },
    handleClick(item) {
      this.$emit('picChange', item)
    }
  }
}
</script>
